/**
 * Nav customization state.
 *
 * `preferences` mirrors the current organization's users.nav_preferences
 * entry. It starts from localStorage, is replaced by every sign-in payload
 * (actions/auth.js stores the same payload to localStorage), and is updated
 * after a successful save. `editorOpen` lets the Settings page open the editor
 * that NewNav owns, since only NewNav knows which pages this user can see.
 */
import { RESET_PASSWORD, USER_AUTH } from '../actions/auth';
import { readStoredNavPreferences, readStoredNavPreferencesOrganizationId } from '../containers/NewNav/navPreferences';

const initialState = {
  preferences: readStoredNavPreferences(),
  // The org `preferences` belong to, per tab: another tab can switch orgs, and
  // a save sends this so the server can refuse it (see saveNavPreferences).
  organizationId: readStoredNavPreferencesOrganizationId(),
  editorOpen: false,
  editorSource: null,
  // Bumped on every open; NewNav keys the editor on it so each opening starts
  // from the saved preferences.
  editorSession: 0,
};

// eslint-disable-next-line default-param-last
export default (state = initialState, action) => {
  switch (action.type) {
    case USER_AUTH.LOGGED_IN:
    case USER_AUTH.VALID:
    case RESET_PASSWORD.SUCCESS:
      return {
        ...state,
        preferences: action.payload?.navPreferences || null,
        organizationId: action.payload?.navPreferencesOrganizationId ?? null,
      };
    case USER_AUTH.LOGGED_OUT:
      return {
        ...state,
        preferences: null,
        organizationId: null,
        editorOpen: false,
        editorSource: null,
      };
    case 'OPEN_NAV_CUSTOMIZER':
      // A second open (the chip, Settings) must not remount an editor that is
      // already open and drop its drafts.
      if (state.editorOpen) return state;
      return {
        ...state,
        editorOpen: true,
        editorSource: action.source || null,
        editorSession: state.editorSession + 1,
      };
    case 'CLOSE_NAV_CUSTOMIZER':
      return {
        ...state,
        editorOpen: false,
      };
    case 'SET_NAV_PREFERENCES':
      return {
        ...state,
        preferences: action.preferences,
      };
    default:
      return state;
  }
};
